import { client } from '../utils'
import { lms as endpoints } from '../api_urls'

const selectLMS = backendLmsIdentifier => {
  switch (backendLmsIdentifier) {
    case 'canvas':
      return 'canvas_v2'
    case 'canvas_v2':
      return 'canvas_v2'
    case 'brightspace':
      return 'brightspace'
    default:
      throw new Error(`LMS Identifier "${backendLmsIdentifier}" not recognized`)
  }
}

export const fetchCourseLmsData = async dispatch => {
  let resp
  try {
    resp = await client.get(endpoints.show())
  } catch (e) {
    dispatch(reportError('Getting the LMS settings failed.', e))
    return
  }
  const canvasUrl = resp.data.canvasUrl
  const canvasCoursenum = resp.data.canvasCoursenum
  const courseTitle = resp.data.courseTitle
  const launchToolCreated = resp.data.launchToolCreated
  const selectedLms = selectLMS(resp.data.selectedLms)

  dispatch(updateLmsData(canvasUrl, canvasCoursenum, courseTitle))
  dispatch(updateLaunchToolCreated(launchToolCreated))
  dispatch(updateSelectedLms(selectedLms))

  return resp.data
}

export const postLmsSettings = async (data, dispatch) => {
  let resp
  try {
    resp = await client.post(endpoints.save(), data)
    alertUser(`Your changes have been saved!`, 6000, 'success')
  } catch (e) {
    alertUser('')
    let errorMessage = e.response?.data?.error ?? 'An unexpected error occurred.'
    dispatch(updateFormError(errorMessage, 'danger'))
    return
  }
  const canvasUrl = data.canvasUrl
  const canvasCoursenum = data.canvasCoursenum

  dispatch(updateLmsData(canvasUrl, canvasCoursenum))
  dispatch(updateFormError('', 'success'))
  return resp.data
}

export const postAssessmentIsSynced = async (data, dispatch) => {
  let resp
  try {
    resp = await client.post(endpoints.syncAssessments(), data)

    const assessments = resp.data
    dispatch(updateAssessments(assessments))

    return resp.data
  } catch (e) {
    dispatch(reportError('Syncing the assessment to the LMS failed.', e))
  }
}

export const fetchLmsCourses = async dispatch => {
  let resp
  try {
    resp = await client.get(endpoints.courses())
  } catch (e) {
    dispatch(reportError('Getting the LMS courses failed.', e))
    return
  }

  const lmsCourses = resp.data.courses
  dispatch(setLmsCourseList(lmsCourses))

  return resp.data
}

export const fetchCourseLmsToken = async dispatch => {
  let resp
  try {
    resp = await client.get(endpoints.token())
  } catch (e) {
    dispatch(reportError('Getting the LMS Authenticate Token failed.', e))
    return
  }
  const courseToken = resp.data.courseToken
  dispatch(updateLmsToken(courseToken))

  return resp.data
}

export const fetchAssessments = async dispatch => {
  let resp
  try {
    resp = await client.get(endpoints.assessments())
  } catch (e) {
    dispatch(reportError('Getting the list of assessments failed.', e))
    return
  }

  const assessments = resp.data
  dispatch(updateAssessments(assessments))

  return resp.data
}

export const checkBrightspaceConfiguration = async dispatch => {
  let resp
  try {
    resp = await client.get(endpoints.bsAKP())
  } catch (e) {
    dispatch(reportError('Error checking Brightspace configuration.', e))
    return
  }

  const isConfigured = resp.data.configured
  dispatch(updateBrightspaceConfiguration(isConfigured))
  return resp.data
}

export const updateLmsData = (canvasUrl, canvasCoursenum, courseTitle) => {
  return {
    type: 'UPDATE_LMS_DATA',
    canvasUrl,
    canvasCoursenum,
    courseTitle,
    formErrorMsg: '',
  }
}

export const updateFormError = (formErrorMsg, msgClass) => {
  return {
    type: 'UPDATE_FORM_ERROR',
    formErrorMsg,
    msgClass,
  }
}

export const setCourseSelectFormError = selectErrorMsg => {
  return {
    type: 'UPDATE_SELECT_FORM_ERROR',
    selectErrorMsg,
  }
}

export const updateLmsToken = courseToken => {
  return {
    type: 'UPDATE_LMS_TOKEN',
    courseToken,
  }
}

export const setLmsCourseList = courseList => {
  return {
    type: 'SET_LMS_COURSE_LIST',
    courseList,
  }
}

export const updateLaunchToolCreated = launchToolCreated => {
  return {
    type: 'UPDATE_LAUNCH_TOOL_CREATED',
    launchToolCreated,
  }
}

export const updateSelectedLms = selectedLms => {
  return {
    type: 'UPDATE_SELECTED_LMS',
    selectedLms,
  }
}

export const updateAssessments = assessments => {
  return {
    type: 'UPDATE_ASSESSMENTS',
    assessments,
  }
}

export const updateBrightspaceConfiguration = isConfigured => {
  return {
    type: 'UPDATE_BRIGHTSPACE_CONFIGURATION',
    configured: isConfigured,
  }
}

export const reportError = (msg, error) => {
  alertUser(
    `${msg} Try again later or contact MyEducator support.`,
    6000,
    'danger'
  )
  return {
    type: 'REPORT_ERROR',
    payload: { msg, error },
  }
}

export const alertUser = (msg, timeout, kind) => {
  window.$.meDialog.topMessage(msg, timeout, kind)
}
